var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 47,
    viewBox: "0 0 45 47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1932 3.87577C27.4036 -1.29192 35.8818 -1.29192 41.0922 3.87577C46.3026 9.04347 46.3026 17.452 41.0923 22.6198C39.1218 24.574 36.6328 25.8511 33.8942 26.3131C31.5464 26.7092 29.1706 26.485 26.9647 25.6665L22.1594 30.4323L19.2318 27.5287L23.9224 22.8767L21.9342 20.9048L0.99667 41.6704L0 36.8516L19.1215 17.8873C18.2961 15.6994 18.0701 13.3431 18.4694 11.0147C18.9351 8.29862 20.2228 5.83007 22.1932 3.87577ZM34.7469 13.3272C35.5975 13.3272 36.3972 12.9988 36.9986 12.4023C38.2402 11.1708 38.2402 9.16722 36.9986 7.93592C36.3778 7.32023 35.5623 7.01234 34.7469 7.01234C33.9316 7.01234 33.1161 7.32023 32.4953 7.93592C31.8938 8.53234 31.5626 9.32548 31.5626 10.1691C31.5626 11.0127 31.8938 11.8058 32.4953 12.4023C33.0967 12.9988 33.8964 13.3272 34.7469 13.3272Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1224 32.5957L17.2431 29.5007L20.171 32.4045L17.0503 35.4996L14.1224 32.5957Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1337 34.5681L10.3198 36.3672L13.2477 39.271L15.0616 37.472L12.1337 34.5681Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52428 44.0962L8.33031 38.3378L11.2582 41.2416L5.45216 47L2.52428 44.0962Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixKey);
export default __webpack_public_path__ + "static/media/pix-key.82495d6de76ea3fd17982040009941db.svg";
export { ForwardRef as ReactComponent };